module.exports = __webpack_public_path__ + "img/eye quantity.e1c311c3.png";